import Modal from 'react-modal';
import PropTypes from 'prop-types';

import './ModalBase.css';

import { buildClass } from '../../libs/classes';

/**
 * Base modal window
 * @component
 */
const ModalBase = ({ isOpen, className, style, overlayClassName, onAfterOpen, onRequestClose, children }) => {
	return (
		<Modal
			appElement={document.getElementById('root')}
			className={String(buildClass('modal-base', className))}
			isOpen={isOpen}
			overlayClassName={String(buildClass('modal-overlay-base', overlayClassName))}
			style={style}
			onAfterOpen={onAfterOpen}
			onRequestClose={onRequestClose}
		>
			{children}
		</Modal>
	);
};

ModalBase.propTypes = {
	// Open state
	isOpen: PropTypes.bool,
	// Custom class
	className: PropTypes.string,
	// Custom style object
	style: PropTypes.object,
	// Custom class for overlay
	overlayClassName: PropTypes.string,
	// Callback on opening dialog
	onAfterOpen: PropTypes.func,
	// Callback on close dialog request
	onRequestClose: PropTypes.func,
	// Modal content
	children: PropTypes.node.isRequired,
};

export default ModalBase;
